import Color from 'color';

export const getColorCodeRGBA = (color: Color) => {
  const str = color
    .rgb()
    .array()
    .join(',');
  return `rgba(${str})`;
};
